import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetStreetScapeTrackerTableRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetStreetScapeTrackerTable`
});

export const CreateStreetScapeEntryRequest = (streetScapeTrackerCreateDto) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}SiteTracker/CreateStreetScapeTracker`,
	data: streetScapeTrackerCreateDto
});

export const GetCommentsHistoryRequest = (id, commentType) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetStreetScapeCommentsHistory`,
	params: { id, commentType }
});

export const GetStreetScapeTrackerRequest = (id) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetStreetScapeTracker`,
	params: { id }
});

export const GetStreetScapeTrackerToEditRequest = (id) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetStreetScapeTrackerToEdit`,
	params: { id }
});

export const GetExportTrackerRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetStreetScapeTrackerExport`
});

export const RemoveStreetScapeEntryRequest = (id, user) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}SiteTracker/RemoveStreetScapeEntry`,
	params: { id, user }
});

export const GetReportEmailRequest = (id, user) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetStreetScapeDReportEmail`,
	params: { id, user }
});

export const EditStreetScapeEntryRequest = (streetScapeTrackerForm) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}SiteTracker/EditStreetScapeTracker`,
	data: streetScapeTrackerForm
});

export const GetStreetScapeLocalDropdownRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetStreetScapeLocalDropdown`
});

export const GetStreetScapeClusterDropdownRequest = (local) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetStreetScapeClusterDropdown`,
	params: { local }
});

export const GetStreetScapeSiteNameDropdownRequest = (cluster) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetStreetScapeSiteNameDropdown`,
	params: { cluster }
});

export const GetActivationStatusDropdownRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetActivationStatusDropdown`
});

export const GetD7StatusDropdownRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetD7StatusDropdown`
});
